module.exports = __webpack_public_path__ + "static/media/BottomBackground.629a6d8c.png";